// IE 2026 09 28 / ODOO-342342 (приёмка ie-growth7, Д2 / Д4 / Д5): текст ячеек грида, который раньше показывался сырым значением.
//   * gridText_tags — колонка тегов (AttrTags: таблица {use, title}) в списке: названия через запятую, а не «[object Object],[object Object]» (Д2).
//   * gridText_multiDisplay — подпись мульти-значения ({value, valueStr, valueStr_uk…}) на базовом языке: у узла с переводами valueStr — базовое (en)
//     название, а не копия value. Раньше на en подпись заменялась value: этап пути показывался «stage-1», раздел инструкции — «docs:docs/…#…» (Д4);
//     на uk / ru шла подпись valueStr_{lang}, поэтому ошибку видели только на en.
//   * gridText_labelWidthChars — ширина колонки подписей формы (AttrTabGrid) по самой длинной подписи, без отсечения по 80-му перцентилю (Д5).
const isObj = (x) => !!(x && typeof x === 'object')

export function gridText_tags(value) {
    if (value === null || value === undefined || value === '') return ''
    const list = Array.isArray(value) ? value : [value]
    const out = []
    for (const v of list) {
        if (isObj(v)) {
            if (v.use === false) continue
            const s = v.title ?? v.valueStr ?? v.value ?? ''
            if (s !== '' && s !== null && s !== undefined) out.push(String(s))
        } else if (v !== null && v !== undefined && v !== '') out.push(String(v))
    }
    return out.join(', ')
}

// есть ли у мульти-значения переводы подписи (valueStr_{lang} — непустая строка)
export function gridText_hasTranslations(V) {
    if (!isObj(V)) return false
    for (const k of Object.keys(V)) {
        if (/^valueStr_[a-z]{2}$/.test(k) && typeof V[k] === 'string' && V[k].trim()) return true
    }
    return false
}

// подпись мульти-значения простого типа (AttrStr / AttrTab …): перевод языка интерфейса, иначе — базовое название (valueStr) у узла с переводами, иначе value
export function gridText_multiDisplay(V, translated = '') {
    if (translated) return translated
    if (!isObj(V)) return ''
    // IE 2026 10 14 / ODOO-5800 (бот dev02, карточка RESPONSIBLE-REGISTER из грида Responsibles: поле «Previous values» показывало «[object Object]»):
    // AttrJSON-объект в форме (AttrTabGrid) рисуется деревом строк-детей (attrsTabGrid_from_JSON) — в ячейке значения текст не нужен; сборка строк
    // ставила valueStr = '', но prepare_AttrMulti_all (показ формы / загрузка данных) переписывал его String(value). Как AttrGrid-массив (ODOO-336330)
    if (V.attr_type === 'AttrJSON' && isObj(V.value)) return ''
    if (V.valueStr !== undefined && V.valueStr !== null && String(V.valueStr).trim() && gridText_hasTranslations(V)) return String(V.valueStr)
    return String(V.value || '')
}

// IE 2026 09 29 / ODOO-342342 (ревью ie-dm7 п.2): Д5 (подписи целиком, перенос многострочного текста) — только форма кейса, вкладка About
// (AttrTabGrid-uc-about, addons/ADDON_core/config_guide.py), где жил дефект приёмки. Прочие AttrTabGrid (формы записей, widget-row, настройки
// грида / Ганта / карты) — как на main: колонка подписей по 80-му перцентилю, строки AttrStrMulti в одну строку — и при включённых флагах Д5
export const TABGRID_D5_NAMES = ['AttrTabGrid-uc-about']
export function gridText_tabGridD5(attr) {
    return !!attr && attr.attr_type === 'AttrTabGrid' && TABGRID_D5_NAMES.includes(attr.name)
}

// ширина колонки подписей в символах: самая длинная подпись (+2 на отступы коротких, как autoSizeColumn), не меньше 6 и не больше cap
export function gridText_labelWidthChars(lengths, cap = 30) {
    const list = (lengths || []).filter(n => Number.isFinite(n) && n > 0)
    if (!list.length) return 0
    let m = Math.max(...list)
    if (m < 10) m += 2
    return Math.min(cap, Math.max(6, m))
}

export default { gridText_tags, gridText_hasTranslations, gridText_multiDisplay, gridText_labelWidthChars, gridText_tabGridD5 }   // IE 2026 09 29 / ODOO-342342 (ревью п.2): + gridText_tabGridD5
